import {
  LANGUAGES,
  DEFAULT_LANGUAGE,
  SITE_URL,
  CN_SITE_URL,
  INTERNAL_HOSTNAMES,
  KNOWN_DOMAINS_RE,
  TARGET_BLANK_DOMAINS_RE,
  EU_REPLACE_DOMAINS_RE
} from '../constants';

const validLanguagePaths = Object.values(LANGUAGES).map(({ path }) => path);
const defaultLanguage = LANGUAGES[DEFAULT_LANGUAGE];

export const isInternal = (url) => {
  const { hostname } = new URL(url);
  return INTERNAL_HOSTNAMES.includes(hostname);
};

export const isKnownDomain = (url) => {
  const { hostname } = new URL(url);
  return KNOWN_DOMAINS_RE.test(hostname);
};

export const isTargetBlankDomain = (url) => {
  const { hostname } = new URL(url);
  return TARGET_BLANK_DOMAINS_RE.test(hostname);
};

export const isEuReplaceDomain = (url) => {
  const { hostname } = new URL(url);
  return EU_REPLACE_DOMAINS_RE.test(hostname);
};

export const isRelative = (url) => (
  url === null || !/^(https?|tel|mailto|file)/i.test(url)
);

export const convertAbsoluteToRelative = (url) => {
  const { origin, pathname, search, hash } = new URL(url);
  return pathname.replace(origin, '') + search + hash;
};

export const removeLanguageFromPath = (path) => {
  const [languagePath, ...pathParts] = path.slice(1).split('/');

  if (validLanguagePaths.includes(languagePath)) {
    return `/${pathParts.join('/')}`;
  }

  return path;
};

export const generateLanguagePath = (language, path = '') => {
  if (language === defaultLanguage) {
    return path;
  }

  const languagePath = LANGUAGES[language].path;

  return `${languagePath ? `/${languagePath}` : ''}${path}`;
};

export const getLanguageSiteUrl = (language) => {
  if (language === 'zh-Hans') {
    return CN_SITE_URL;
  }

  return SITE_URL;
};

export const absolutizeCDNUrls = (url) => {
  if (typeof url === 'string' && url.startsWith('//') && url.includes('ctfassets.net')) {
    return `https:${url}`;
  }

  return url;
};

export const convertPdfCDNUrls = (url, language) => {
  if (typeof url !== 'string' || !url.includes('ctfassets.net')) {
    return url;
  }

  const { pathname } = new URL(url);
  if (pathname.endsWith('.pdf')) {
    const pathParts = pathname.split('/');
    const assetId = pathParts[2]; // 2nd segment is the asset ID
    const fileName = pathParts[pathParts.length - 1];
    const path = generateLanguagePath(language || defaultLanguage, `/${assetId}/${fileName}`);
    return `/api/assets${path}`;
  }

  return url;
};

export const convertPathForTracking = (path) => {
  const pathnameWithoutSlash = path.slice(1);
  const isHome = pathnameWithoutSlash === '' || validLanguagePaths.includes(pathnameWithoutSlash);

  if (isHome) {
    return `${pathnameWithoutSlash.length > 0 ? `${pathnameWithoutSlash}/` : ''}home`;
  }

  return pathnameWithoutSlash;
};
